// Figma "cases" > KLM: section 55:640, frames 55:641 (cover; card 55:723 and image 55:727 are section-level layers), 55:671, 55:698
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/klm/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const IMG = own

export const klm: Case = {
    name: "KLM",
    theme: {
        page: "#00092e",
        gradient: "linear-gradient(180deg, #00092e 0%, #00275e 100%)",
        stops: [
            [0, 9, 46, 0],
            [0, 39, 94, 1],
        ],
        fill: "#00a1e4",
        line: "#00a1e4",
        tone: "dark",
        title: "#ffffff",
        body: "rgba(255, 255, 255, 0.6)",
    },
    modules: [
        {
            type: "grid",
            columns: [
                {
                    w: 220,
                    cells: [
                        {
                            h: 220,
                            tag: { logo: "/work/klm/logo.svg", logoBox: [20, 21, 63, 37], text: "KLM\nDUTCH AIRLINER\n\nMAINTENANCE APP" },
                        },
                        { h: 626 },
                    ],
                },
                {
                    w: 350,
                    cells: [
                        {
                            h: 443,
                            card: {
                                title: "Innovative efficiency through AR",
                                body: "KLM commissioned Dept with an AR research project to implement within their maintenance processes. Created together with Tim Dekens.",
                            },
                        },
                        { h: 400 },
                    ],
                },
                { w: 982, cells: [{ h: 825, image: IMG("1-1", 1964, 1650) }, { h: 18 }] },
            ],
        },
        {
            type: "grid",
            columns: [
                { w: 1107, cells: [{ h: 846, image: IMG("2-1", 2214, 1692) }] },
                { w: 446, cells: [{ h: 652, image: IMG("2-2", 892, 1304) }, { h: 191 }] },
            ],
        },
        { type: "grid", columns: [{ w: 1557, cells: [{ h: 846, image: IMG("3-1", 3114, 1692) }] }] },
    ],
}
